import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import { fetchQuestionValidationRuleSuccessAction } from '../actions/questionValidationRule';
type State = {
    questionValidationRule: {
        byId: { [id: string]: any } | null;
        allIds: Array<string | any> | null;
    };
    loading: boolean;
    attempted: boolean;
    errorMessage: null | any;
};
const INITIAL_STATE: State = {
    questionValidationRule: {
        byId: {},
        allIds: [],
    },
    loading: false,
    attempted: false,
    errorMessage: null,
};

const fetchQuestionValidationRule = (state: State): State => {
    return {
        ...state,
        loading: true,
        attempted: true,
    };
};

const fetchQuestionValidationRuleSuccess = (
    state: State,
    action: PayloadAction<fetchQuestionValidationRuleSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'code',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        questionValidationRule: {
            ...state.questionValidationRule,
            byId: byId,
            allIds: allIds,
        },
    };
};

const fetchQuestionValidationRuleFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

// The rules are locale specific - the API returns a different
// regExExpression per language (dot vs comma decimal separator), so the
// once-per-session `attempted` guard has to reopen after a language change
// or the containers keep validating against the previous locale's format.
const updateLanguageApplicationUserSuccess = (state: State): State => {
    return {
        ...state,
        attempted: false,
    };
};

const questionValidationRule = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_QUESTION_VALIDATION_RULE]: fetchQuestionValidationRule,
    [ActionTypes.FETCH_QUESTION_VALIDATION_RULE_SUCCESS]:
        fetchQuestionValidationRuleSuccess,
    [ActionTypes.FETCH_QUESTION_VALIDATION_RULE_FAILED]:
        fetchQuestionValidationRuleFailed,
    [ActionTypes.UPDATE_LANGUAGE_APPLICATION_USER_SUCCESS]:
        updateLanguageApplicationUserSuccess,
});

export default questionValidationRule;
